<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_porfolio"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="11"
      viewBox="0 0 12 11"
      class="scaling-svg"
    >
      <g id="Icon_porfolio-2" data-name="Icon_porfolio" transform="translate(0.167 -0.25)">
        <path
          id="Path"
          d="M.583,1.167A.583.583,0,0,0,1.167.583h0A.583.583,0,0,0,.583,0h0A.583.583,0,0,0,0,.583H0a.583.583,0,0,0,.583.583Z"
          transform="translate(5.25 5.25)"
        />
        <path
          id="Shape"
          d="M10.8,11H1.2A1.213,1.213,0,0,1,0,9.778V3.667A1.213,1.213,0,0,1,1.2,2.444H3.6a2.73,2.73,0,0,1,.473-1.5A2.239,2.239,0,0,1,6,0,2.239,2.239,0,0,1,7.927.942a2.717,2.717,0,0,1,.474,1.5h2.4A1.213,1.213,0,0,1,12,3.667V9.778A1.213,1.213,0,0,1,10.8,11ZM1.2,8.556v.611a.606.606,0,0,0,.6.611h8.4a.606.606,0,0,0,.6-.611V8.556Zm.6-4.889a.606.606,0,0,0-.6.611V7.333h9.6V4.278a.606.606,0,0,0-.6-.611ZM6,1.222a1.079,1.079,0,0,0-.953.433,1.462,1.462,0,0,0-.247.789H7.2a1.461,1.461,0,0,0-.247-.789A1.079,1.079,0,0,0,6,1.222Z"
          transform="translate(-0.167 0.25)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AccountancyIcon extends Vue {}
</script>

<style>
</style>
